import React, { Component } from 'react';
import {Grid, Typography} from '@material-ui/core'

export default class TMBlock extends Component {
    constructor(props) {
        super(props);
        this.state = {
            backgroundColor: 'white',
            foreColor: '',
        }
    }

    componentDidMount = () => {
        if (this.props.designation==='C1'||this.props.designation==='B2'||this.props.designation==='A3'){
            this.setState({backgroundColor:'yellow'})
        } else if (this.props.designation==='C2'||this.props.designation==='C3'||this.props.designation==='B3'){
            this.setState({backgroundColor:'red', foreColor:'wheat'})
        } else {
            this.setState({backgroundColor:'green', foreColor:'whitesmoke'})
        }
    };
    
    
    render() {return (
        <td style={{
           border: '1px dashed #bcbec0',
        //    backgroundColor: 'orange',
           verticalAlign: 'top',
           width: 250,
           height:200
        }}>
            <Typography
                style={{
                    padding:5,
                    backgroundColor:this.state.backgroundColor,
                    color: this.state.foreColor
                }}
            >
                <b>{this.props.designation}</b>
            </Typography>

            <Grid
                container
                direction='column'
                style={{paddingLeft:10}}
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
            >
                {this.props.array.map((item, i) => {
                    return item.final_classification === this.props.designation ? 
                    <div>
                    <Typography key={i} style={{textAlign:'left', borderBottom: '1px solid', width:'100%'}}>
                        <b>{item.name + (item.final_classification!==item.original_classification? "*":"")}</b> #{item.assessee_id}<br/>
                        {item.job_title} [{item.store_code}]
                    </Typography>
                    </div> : null

                })}
                
            </Grid>
        </td>
    );}
}